import React from "react";
import { TextField } from "@mui/material";

const GroupDescription = (props) => {
  const { groupDesc, setGroupDesc } = props;
  return (
    <TextField
      id="vehicle-group-description"
      label="Description"
      multiline
      fullWidth
      value={groupDesc}
      onChange={({ target }) => setGroupDesc(target?.value)}
      variant="outlined"
      placeholder="Describe the group"
      rows={2}
    />
  );
};

export default GroupDescription;
